import { Backdrop, Box, CircularProgress, Dialog } from '@mui/material'

const CircleProgressDialog = (props) => {

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.open}
    >
        <CircularProgress />
    </Backdrop>
  );


}

export default CircleProgressDialog